import { useState, useEffect } from 'react';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { ICommunityResponse } from '@scale/shared/types/Community';

/**
 * Deprecated, use useGetPlatformCommunities instead
 */
const useGetCommunities = (url = 'corp-api/scalers/slack_channels/communities') => {
  const [communities, setCommunities] = useState<ICommunityResponse[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getCommunities = async () => {
      try {
        setIsLoading(true);
        const communities = await apiFetch(null, url);
        setCommunities(communities);
      } catch (err) {
        setError(err.toString());
      } finally {
        setIsLoading(false);
      }
    };

    getCommunities();
  }, [url]);

  return { communities, isLoading, error };
};

export default useGetCommunities;
